import React, { useEffect } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";


import './style.css'
import { UseRoleContext } from "../../../utils/RoleContext";
import { Box } from "@mui/material";

const DefaultLayout = () => {

  const nav = useNavigate();
  const context = UseRoleContext()

  useEffect(() => {
    if (context.IsAdminRh || context.isAssistantRh || context.isDevRh || context.isModerateur || context.isManager) {
      nav("/")
    }
  }, [context.basicUserInfo])
  return (
<Box
  sx={{
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background : 'rgba(5, 17, 56, 1)'
  }}
>
  <Outlet />
</Box>



  );
};

export default DefaultLayout;